import {signal} from "@preact/signals-react";

export const numbersData = signal({})
export const isLoadingNumbers = signal(false)